import { useEffect, useState } from 'react';

import services from 'services';

const useTitle = () => {
  const [titleState, setTitleState] = useState(services.appFrame.title.getTitleState);
  useEffect(() => {
    return services.appFrame.title.onTitleChange((newTitleState) => {
      setTitleState(newTitleState);
    });
  }, []);

  return titleState;
};

export default useTitle;
